import React, { Component } from "react";
import faStyles from 'font-awesome/css/font-awesome.css'

import "./UserLinks.css";

class UserLinks extends Component {
  getLinkElements() {
    const { userLinks } = this.props.config;
    const { labeled } = this.props;
    return userLinks.map(link => (
      <a key={link.label} href={link.url} target="_blank">
        {labeled ? link.label : <span className={link.iconClassName} cssModule={faStyles} />}
      </a>
    ));
  }
  render() {
    const { userLinks } = this.props.config;
    if (!userLinks) {
      return null;
    }
    return <div className="UserLinks">{this.getLinkElements()}</div>;
  }
}

export default UserLinks;



// WEBPACK FOOTER //
// ./src/components/UserLinks/UserLinks.jsx